import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { ReactComponent as CloseBtn } from "../../../assets/icons/Icon.svg";
import { Box } from "@mui/material";
import { CONSULTATION_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import SubmitBtn from "./components/Buttons/SubmitBtn";
import InputField from "./components/Inputs/InputField";
import Course from "./components/SelectCollection/Course";
// import Teacher from "./components/SelectCollection/Teacher";
import WhereComing from "./components/SelectCollection/WhereComing";
import CancelReason from "./components/SelectCollection/CancelReason";
import Status from "./components/SelectCollection/Status";
// import Group from "./components/SelectCollection/Group";
import { validationSchema } from "./components/ValidationSchema/ValidationSchema";
import Worker from "./components/SelectCollection/Worker";
import ContactTool from "./components/SelectCollection/ContactTool";
import Result from "./components/SelectCollection/Result";
import ConsultationStatus from "./components/SelectCollection/ConsultationStatus";
import CallDates from "./components/SelectCollection/CallDates";

const ConsultationModal = () => {
  const dispatch = useDispatch();
  const { consultationModalData: modalData } = useSelector(
    (state) => state.consultationModal
  );
  const inputNameArr1 = ["applicationDate", "studentPhone"];




  const inputNameArr2 = [
    "nextApplicationDate",
    "constDate",
    "firstContactDate",
    // "lastContactDate",
  ];
  const ValidationSchema = validationSchema(modalData);
  const formik = useFormik({
    initialValues: {
      // studentName: modalData?.studentName || "",
      constDate: modalData?.constDate || "",
      course: modalData?.course || "",
      salesDate: modalData?.salesDate || "",
      whereComing: modalData?.whereComing || "",
      workers: modalData?.workers || "",
      applicationDate: modalData?.applicationDate || "",
      nextApplicationDate: modalData?.nextApplicationDate || "",
      contactTool: modalData?.contactTool || "",
      callDates: modalData?.callDates || "",
      result: modalData?.result || "",
      cancelReason: modalData?.cancelReason || "",
    },
    validationSchema: ValidationSchema,
  });
  const setInputValue = useCallback(
    (key, value) =>
      formik.setValues({
        ...formik.values,
        [key]: value,
        ...(key === "course" ? { group: "" } : {}),
      }),
    [formik]
  );

  const updateModalState = (keyName, value) => {
    setInputValue(keyName, value);
    dispatch({
      type: CONSULTATION_MODAL_ACTION_TYPE.GET_CONSULTATION_MODAL,
      payload: {
        data: {
          ...modalData,
          [keyName]: value,
          ...(keyName === "course" ? { group: "" } : {}),
        },
        openModal: true,
      },
    });
  };
  const closeModal = () => {
    dispatch({
      type: CONSULTATION_MODAL_ACTION_TYPE.GET_CONSULTATION_MODAL,
      payload: { data: {}, openModal: false },
    });
  };

  useEffect(() => {
    setInputValue("studentPhone", modalData?.studentPhone || "");
  }, [modalData.status, modalData?.group]);

  // console.log(ValidationSchema);

  return (
    <div className="create-update-modal-con teacher-modal">
      <div className="create-update-modal">
        <div className="create-update-modal-head">
          <h2>{modalData?._id ? "Lead yenilə" : "Lead əlavə et"}</h2>
          <CloseBtn onClick={closeModal} />
        </div>

        <Box
          onSubmit={(e) => e.preventDefault()}
          component="form"
          sx={{
            width: 500,
            maxWidth: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div className="create-update-modal-form">
            <InputField
              inputName="studentName"
              formik={formik}
              setInputValue={setInputValue}
              modalData={modalData}
              updateModalState={updateModalState}
            />

            {modalData?._id && (
              <InputField
                inputName="email"
                formik={formik}
                setInputValue={setInputValue}
                modalData={modalData}
                updateModalState={updateModalState}
              />
            )}

            <InputField
              inputName="socialMediaName"
              formik={formik}
              modalData={modalData}
              updateModalState={updateModalState}
            />

            {/* {modalData?._id && (
              <InputField
                inputName="fin"
                formik={formik}
                modalData={modalData}
                updateModalState={updateModalState}
              />
            )} */}

            <div className="input-couples birthday " style={{ margin: "0" }}>
              {inputNameArr1.map((name, index) => (
                <InputField
                  key={index}
                  inputName={name}
                  formik={formik}
                  modalData={modalData}
                  updateModalState={updateModalState}
                />
              ))}
            </div>

            {modalData?._id && (
              <div className="input-couples birthday " style={{ margin: "0" }}>
                {inputNameArr2.map((name, index) => (
                  <InputField
                    key={index}
                    inputName={name}
                    formik={formik}
                    modalData={modalData}
                    updateModalState={updateModalState}
                  />
                ))}
              </div>
            )}

            <WhereComing
              modalData={modalData}
              updateModalState={updateModalState}
              formik={formik}
            />
            <InputField
              inputName="whereComingDescription"
              formik={formik}
              modalData={modalData}
              updateModalState={updateModalState}
            />
            <Course
              modalData={modalData}
              updateModalState={updateModalState}
              formik={formik}
            />
            <Worker
              modalData={modalData}
              updateModalState={updateModalState}
              formik={formik}
            />

            {modalData?._id && (
              <>
                {/* <Group
                  modalData={modalData}
                  updateModalState={updateModalState}
                  formik={formik}
                /> */}
                {/* <Teacher
                  modalData={modalData}
                  updateModalState={updateModalState}
                  formik={formik}
                /> */}
                <ContactTool
                  modalData={modalData}
                  updateModalState={updateModalState}
                  formik={formik}
                />
                <Result
                  modalData={modalData}
                  updateModalState={updateModalState}
                  formik={formik}
                />

                <Status
                  modalData={modalData}
                  updateModalState={updateModalState}
                  formik={formik}
                />
                <CallDates
                  modalData={modalData}
                  updateModalState={updateModalState}
                  formik={formik}
                />
                <ConsultationStatus
                  modalData={modalData}
                  updateModalState={updateModalState}
                  formik={formik}
                />
                {/* {modalData.status === "cancelled" && ( */}
                <CancelReason
                  modalData={modalData}
                  updateModalState={updateModalState}
                  formik={formik}
                />
                {/* )} */}

                {/* {modalData.status === "sold" && ( */}
                <div className="input-only birthday ">
                  <InputField
                    inputName="contractDate"
                    formik={formik}
                    modalData={modalData}
                    updateModalState={updateModalState}
                  />
                </div>
                {/* )} */}
              </>
            )}

            <InputField
              inputName="addInfo"
              formik={formik}
              modalData={modalData}
              updateModalState={updateModalState}
            />
          </div>
        </Box>

        {modalData?._id ? (
          // <div className="create-update-modal-btn-con">
          <SubmitBtn formik={formik} modalData={modalData} funcType="update" />
        ) : (
          // </div>
          <SubmitBtn formik={formik} modalData={modalData} funcType="create" />
        )}
      </div>
    </div>
  );
};

export default ConsultationModal;
